import { render, staticRenderFns } from "./delete-warning.vue?vue&type=template&id=6bc955fa&scoped=true"
import script from "./delete-warning.vue?vue&type=script&lang=js"
export * from "./delete-warning.vue?vue&type=script&lang=js"
import style0 from "./delete-warning.vue?vue&type=style&index=0&id=6bc955fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc955fa",
  null
  
)

export default component.exports